import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { Body, CardContainer, Date, Bottom, Bookmark } from './style';
import Icon from '../../Icon';
import { downloadResource } from '../../../../utils/fileDownload';
import { formatFileSize } from '../../../../utils/formatFileSize';
import { humanize } from '../../../../utils/formatSession';
import theme from '../../../theme';
import { BOOKMARK_SET } from '../../../../app/redux/actions/bookmarks';
import Text from '../../Text';
import CTA from '../../CTA';
import { getUrlWithToken } from '../../../../utils/common';

const CardDocumentsSmall = ({ data, onClick, isLast, setBookmark }) => {
  const [file, setFile] = useState();
  const [isBookmark, setIsBookmark] = useState(data?.bookmarked);

  useEffect(() => {
    if (data?.file) setFile(data.file);
    if (data?.bookmarked) setIsBookmark(true);
    else setIsBookmark(false);
  }, [data]);

  const handleOnclickBookmark = () => {
    setBookmark({ id: data?.id, action: !isBookmark });
    setIsBookmark(!isBookmark);
  };

  return (
    <CardContainer className={isLast ? 'last' : ''}>
      <div className="flex-wrapper">
        <Date>
          {humanize(data?.created)} fa -{' '}
          {dayjs((data?.created || 0) * 1000).format('DD/MM/YYYY')}
        </Date>
        <Bookmark onClick={handleOnclickBookmark}>
          <Icon
            size={20}
            type="star-01"
            fill={isBookmark ? theme().colors.link : 'none'}
          />
        </Bookmark>
      </div>
      <Body>
        <div>
          <Text type="h3" className="link ellipsis" onClick={onClick}>
            {data.title}
          </Text>
          <Text type="b4" className="ellipsis">
            {!(data?.document_typology?.length > 0) && '-'}
            {(data?.document_typology || []).map((t, i) => (
              <span key={`tag-${t?.id}`}>
                {i === 0 ? '' : '- '}
                {t?.name}{' '}
              </span>
            ))}
            <span /> {/* MISTERY: needed to render the upper typologies... */}
          </Text>
          {file && (
            <Bottom>
              <div className="size">
                {file?.extension?.toUpperCase()} - {formatFileSize(file?.size)}
              </div>
              <CTA
                onClick={() => {
                  downloadResource(getUrlWithToken(file?.url), file?.filename);
                }}
                type="tertiary"
                btnText="Download"
                icon="download-01"
                iconSize={18}
                bottomRight
              />
            </Bottom>
          )}
        </div>
      </Body>
    </CardContainer>
  );
};

CardDocumentsSmall.propTypes = {
  isLast: PropTypes.bool,
  data: PropTypes.object,
  onClick: PropTypes.func,
  setBookmark: PropTypes.func,
};

export default connect(
  (state) => ({}),
  (dispatch) => ({
    setBookmark: ({ id, action }) =>
      dispatch({
        type: BOOKMARK_SET._REQUEST,
        id,
        action,
        item_type: 'document',
      }),
  })
)(CardDocumentsSmall);
